export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {authToken},
      } = store.getState()
      if (authToken) {
        config.headers.Authorization = `${authToken.id}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
